import {IRegPointer} from  "/@lib@/commons/registry.js";
import {Action} from  "/@lib@/commons/actions.js";
import {IDepotResEnv} from  "/@lib@/store/depot.js";

export abstract class DepotResAction<C extends IRegPointer<IDepotResEnv>> extends Action<C> {

	/* Perm appliquée pour évaluer la visibilité de l'action. */
	protected _visResPerms: string[];

	/* Perm appliquée pour évaluer l'activation de l'action. */
	protected _enableResPerms: string[];

	constructor(id: string) {
		super(id);
	}

	isVisible(ctx: C): boolean {
		if (!super.isVisible(ctx)) return false;
		return this.checkResPerms(this._visResPerms, ctx);
	}

	isEnabled(ctx: C): boolean {
		if (!super.isEnabled(ctx)) return false;
		return this.checkResPerms(this._enableResPerms, ctx);
	}

	checkResPerms(perms: string | string[], ctx: C): boolean {
		if (!ctx.reg.env.nodeInfos) return false;
		if (perms && ctx.reg.env.path) {
			return ctx.reg.hasPermission(perms, ctx.reg.env.nodeInfos.roles);
		}
		return true
	}

	requireResVisiblePerm(perms: string | string[]): this {
		if (perms) {
			if (Array.isArray(perms)) {
				for (let i = 0; i < perms.length; i++) this.requireResVisiblePerm(perms[i]);
			} else {
				if (!this._visResPerms) this._visResPerms = [];
				if (this._visResPerms.indexOf(perms) == -1) this._visResPerms.push(perms);
			}
		}
		return this;
	}

	requireResEnabledPerm(perms: string | string[]): this {
		if (perms) {
			if (Array.isArray(perms)) {
				for (let i = 0; i < perms.length; i++) this.requireResEnabledPerm(perms[i]);
			} else {
				if (!this._enableResPerms) this._enableResPerms = [];
				if (this._enableResPerms.indexOf(perms) == -1) this._enableResPerms.push(perms);
			}
		}
		return this;
	}
}
